import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  /**
   * Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: any;
};

export type IQuery = {
  __typename?: 'Query';
  invitationValid?: Maybe<Scalars['Boolean']>;
  invitationStatusses: Array<Array<Maybe<Scalars['String']>>>;
  invitations: IPaginatedInvitationsType;
  employee?: Maybe<IEmployeeType>;
  employees: IPaginatedEmployeesType;
  company: ICompanyType;
  user?: Maybe<IUserType>;
};


export type IQueryInvitationValidArgs = {
  invitationId: Scalars['String'];
};


export type IQueryInvitationsArgs = {
  orderBy?: Maybe<IEmployeeOrder>;
  ascending?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  budgetId?: Maybe<Scalars['ID']>;
  status?: Maybe<IInvitationStatus>;
};


export type IQueryEmployeeArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type IQueryEmployeesArgs = {
  orderBy?: Maybe<IEmployeeOrder>;
  ascending?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  budgetId?: Maybe<Scalars['ID']>;
  status?: Maybe<IInvitationStatus>;
};


export type IQueryUserArgs = {
  uid?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type IPaginatedInvitationsType = {
  __typename?: 'PaginatedInvitationsType';
  count: Scalars['Int'];
  objects: Array<IInvitationType>;
};

export type IInvitationType = {
  __typename?: 'InvitationType';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  lastSent?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  employee: IEmployeeType;
  budget: IBudgetType;
  statusDisplay: Scalars['String'];
  canSend: Scalars['Boolean'];
};


export type IEmployeeType = {
  __typename?: 'EmployeeType';
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  locale: ILocaleChoices;
  firstName: Scalars['String'];
  lastNamePrefix: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  company: ICompanyType;
  personnelNumber: Scalars['String'];
  lastInvitation: IInvitationType;
  invitations: Array<IInvitationType>;
};

/** An enumeration. */
export enum ILocaleChoices {
  NlNl = 'NL_NL',
  NlBe = 'NL_BE',
  FrBe = 'FR_BE'
}

export type ICompanyType = {
  __typename?: 'CompanyType';
  id: Scalars['ID'];
  name: Scalars['String'];
  street: Scalars['String'];
  houseNumber: Scalars['String'];
  houseNumberAdditional: Scalars['String'];
  zipCode: Scalars['String'];
  city: Scalars['String'];
  kvkId: Scalars['String'];
  btwId: Scalars['String'];
  fallbackEmail: Scalars['String'];
  invoiceCompanyName: Scalars['String'];
  invoiceName: Scalars['String'];
  invoiceEmail: Scalars['String'];
  budgets: Array<IBudgetType>;
  users: Array<IUserType>;
};

export type IBudgetType = {
  __typename?: 'BudgetType';
  id: Scalars['ID'];
  name: Scalars['String'];
  value: Scalars['String'];
  description: Scalars['String'];
  infoUrl: Scalars['String'];
};

export type IUserType = {
  __typename?: 'UserType';
  id: Scalars['ID'];
  locale: ILocaleChoices;
  firstName: Scalars['String'];
  lastNamePrefix: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  company: ICompanyType;
  jobTitle: Scalars['String'];
  phone: Scalars['String'];
  isMainUser: Scalars['Boolean'];
};

export enum IEmployeeOrder {
  UpdatedAt = 'UPDATED_AT',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Budget = 'BUDGET',
  Email = 'EMAIL',
  Status = 'STATUS',
  PersonnelNumber = 'PERSONNEL_NUMBER'
}

/** An enumeration. */
export enum IInvitationStatus {
  Invited = 'INVITED',
  CancelledByEmployer = 'CANCELLED_BY_EMPLOYER',
  Scheduled = 'SCHEDULED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED'
}

export type IPaginatedEmployeesType = {
  __typename?: 'PaginatedEmployeesType';
  count: Scalars['Int'];
  objects: Array<IEmployeeType>;
};

export type IMutation = {
  __typename?: 'Mutation';
  /**
   * Mutation to set the password for an existing user, and optionally
   * change some user information
   */
  setPassword?: Maybe<ISetPasswordMutation>;
  /** Mutation to request an email with password reset link */
  resetPassword?: Maybe<IResetPasswordMutation>;
  /** Mutation to create a user */
  createUser?: Maybe<ICreateUserMutation>;
  /** Mutation to update user information */
  updateUser?: Maybe<IUpdateUserMutation>;
  /** Mutation to delete user */
  deleteUser?: Maybe<IDeleteUserMutation>;
  /** Verify password and send authentication code in SMS */
  requestAuthenticationCode?: Maybe<IRequestAuthenticationCodeMutation>;
  /**
   * Verify authentication code and return authorization token. Custom implementation
   * of graphql_jwt.ObtainJSONWebToken, which accepts user_id and code arguments
   * instead of username and password.
   */
  obtainToken?: Maybe<IObtainTokenMutation>;
  verifyToken?: Maybe<IVerify>;
  refreshToken?: Maybe<IRefresh>;
  revokeToken?: Maybe<IRevoke>;
  /** Mutation to create an employee and invitation */
  createAndInviteEmployee?: Maybe<ICreateEmployeeMutation>;
  /** Mutation to update employee information */
  updateEmployee?: Maybe<IUpdateEmployeeMutation>;
  /** Mutation to delete employees */
  deleteEmployees?: Maybe<IDeleteEmployeesMutation>;
  /** Mutation to set the status of the latest invitation to cancelled */
  cancelInvitation?: Maybe<ICancelInvitationMutation>;
  /**
   * Resend the Invitation if its eligible. To be eligible it should:
   *     1. Exist
   *     2. Not be SCHEDULED or COMPLETED
   *     3. Be linked to a User from the same company
   *     4. Not have been expired for more than 180 days.
   */
  resendInvitation?: Maybe<IResendInvitationMutation>;
  optOutEmployee?: Maybe<IEmployeeMailOptOutMutation>;
  /** Mutation to set the status of invitations to cancelled */
  cancelInvitations?: Maybe<ICancelInvitationsMutation>;
  /** Create one or more invitations for an existing employee */
  createInvitations?: Maybe<ICreateInvitationsMutation>;
};


export type IMutationSetPasswordArgs = {
  isInitialSignup?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
  uid: Scalars['String'];
  userData: IUserSignupArgsType;
};


export type IMutationResetPasswordArgs = {
  email: Scalars['String'];
};


export type IMutationCreateUserArgs = {
  userData: ICreateUserArgumentsType;
};


export type IMutationUpdateUserArgs = {
  userData: IUpdateUserArgumentsType;
};


export type IMutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type IMutationRequestAuthenticationCodeArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type IMutationObtainTokenArgs = {
  code: Scalars['String'];
  userId: Scalars['ID'];
};


export type IMutationVerifyTokenArgs = {
  token?: Maybe<Scalars['String']>;
};


export type IMutationRefreshTokenArgs = {
  refreshToken?: Maybe<Scalars['String']>;
};


export type IMutationRevokeTokenArgs = {
  refreshToken?: Maybe<Scalars['String']>;
};


export type IMutationCreateAndInviteEmployeeArgs = {
  employeeData: ICreateEmployeeArgumentsType;
  skipDuplicateError?: Maybe<Scalars['Boolean']>;
};


export type IMutationUpdateEmployeeArgs = {
  employeeData: IUpdateEmployeeArgumentsType;
};


export type IMutationDeleteEmployeesArgs = {
  idList: Array<Maybe<Scalars['ID']>>;
};


export type IMutationCancelInvitationArgs = {
  ids: Array<Maybe<Scalars['ID']>>;
};


export type IMutationResendInvitationArgs = {
  invitationId: Scalars['ID'];
};


export type IMutationOptOutEmployeeArgs = {
  mailingIds: Array<IMailingId>;
  token: Scalars['UUID'];
};


export type IMutationCancelInvitationsArgs = {
  ids: Array<Maybe<Scalars['ID']>>;
};


export type IMutationCreateInvitationsArgs = {
  budgetIds: Array<Scalars['ID']>;
  employeeId: Scalars['ID'];
};

/**
 * Mutation to set the password for an existing user, and optionally
 * change some user information
 */
export type ISetPasswordMutation = {
  __typename?: 'SetPasswordMutation';
  user?: Maybe<IUserType>;
};

export type IUserSignupArgsType = {
  password: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastNamePrefix?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** Mutation to request an email with password reset link */
export type IResetPasswordMutation = {
  __typename?: 'ResetPasswordMutation';
  received?: Maybe<Scalars['Boolean']>;
};

/** Mutation to create a user */
export type ICreateUserMutation = {
  __typename?: 'CreateUserMutation';
  user?: Maybe<IUserType>;
};

export type ICreateUserArgumentsType = {
  firstName: Scalars['String'];
  lastNamePrefix?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone: Scalars['String'];
  locale?: Maybe<ILocaleChoices>;
};

/** Mutation to update user information */
export type IUpdateUserMutation = {
  __typename?: 'UpdateUserMutation';
  user?: Maybe<IUserType>;
};

export type IUpdateUserArgumentsType = {
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastNamePrefix?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  locale?: Maybe<ILocaleChoices>;
};

/** Mutation to delete user */
export type IDeleteUserMutation = {
  __typename?: 'DeleteUserMutation';
  success?: Maybe<Scalars['Boolean']>;
};

/** Verify password and send authentication code in SMS */
export type IRequestAuthenticationCodeMutation = {
  __typename?: 'RequestAuthenticationCodeMutation';
  userId: Scalars['ID'];
};

/**
 * Verify authentication code and return authorization token. Custom implementation
 * of graphql_jwt.ObtainJSONWebToken, which accepts user_id and code arguments
 * instead of username and password.
 */
export type IObtainTokenMutation = {
  __typename?: 'ObtainTokenMutation';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  refreshToken: Scalars['String'];
};


export type IVerify = {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar'];
};

export type IRefresh = {
  __typename?: 'Refresh';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type IRevoke = {
  __typename?: 'Revoke';
  revoked: Scalars['Int'];
};

/** Mutation to create an employee and invitation */
export type ICreateEmployeeMutation = {
  __typename?: 'CreateEmployeeMutation';
  employee: IEmployeeType;
  success: Scalars['Boolean'];
};

export type ICreateEmployeeArgumentsType = {
  firstName: Scalars['String'];
  lastNamePrefix?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  email: Scalars['String'];
  personnelNumber?: Maybe<Scalars['String']>;
  locale?: Maybe<ILocaleChoices>;
  budgetId?: Maybe<Scalars['ID']>;
  budgetIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/** Mutation to update employee information */
export type IUpdateEmployeeMutation = {
  __typename?: 'UpdateEmployeeMutation';
  employee?: Maybe<IEmployeeType>;
};

export type IUpdateEmployeeArgumentsType = {
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastNamePrefix?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  personnelNumber?: Maybe<Scalars['String']>;
  locale?: Maybe<ILocaleChoices>;
};

/** Mutation to delete employees */
export type IDeleteEmployeesMutation = {
  __typename?: 'DeleteEmployeesMutation';
  success?: Maybe<Scalars['Boolean']>;
};

/** Mutation to set the status of the latest invitation to cancelled */
export type ICancelInvitationMutation = {
  __typename?: 'CancelInvitationMutation';
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Resend the Invitation if its eligible. To be eligible it should:
 *     1. Exist
 *     2. Not be SCHEDULED or COMPLETED
 *     3. Be linked to a User from the same company
 *     4. Not have been expired for more than 180 days.
 */
export type IResendInvitationMutation = {
  __typename?: 'ResendInvitationMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type IEmployeeMailOptOutMutation = {
  __typename?: 'EmployeeMailOptOutMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export enum IMailingId {
  Reminder = 'REMINDER'
}


/** Mutation to set the status of invitations to cancelled */
export type ICancelInvitationsMutation = {
  __typename?: 'CancelInvitationsMutation';
  success?: Maybe<Scalars['Boolean']>;
};

/** Create one or more invitations for an existing employee */
export type ICreateInvitationsMutation = {
  __typename?: 'CreateInvitationsMutation';
  invitations?: Maybe<Array<IInvitationType>>;
};

export type IInvitationValidQueryVariables = Exact<{
  invitationId: Scalars['String'];
}>;


export type IInvitationValidQuery = (
  { __typename?: 'Query' }
  & Pick<IQuery, 'invitationValid'>
);

export type IForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type IForgotPasswordMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword?: Maybe<(
    { __typename?: 'ResetPasswordMutation' }
    & Pick<IResetPasswordMutation, 'received'>
  )> }
);

export type IObtainAuthTokenMutationVariables = Exact<{
  code: Scalars['String'];
  userId: Scalars['ID'];
}>;


export type IObtainAuthTokenMutation = (
  { __typename?: 'Mutation' }
  & { obtainToken?: Maybe<(
    { __typename?: 'ObtainTokenMutation' }
    & Pick<IObtainTokenMutation, 'token' | 'refreshExpiresIn'>
  )> }
);

export type IRefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type IRefreshTokenMutation = (
  { __typename?: 'Mutation' }
  & { refreshToken?: Maybe<(
    { __typename?: 'Refresh' }
    & Pick<IRefresh, 'token' | 'refreshExpiresIn'>
  )> }
);

export type IRequestAuthCodeMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type IRequestAuthCodeMutation = (
  { __typename?: 'Mutation' }
  & { requestAuthenticationCode?: Maybe<(
    { __typename?: 'RequestAuthenticationCodeMutation' }
    & Pick<IRequestAuthenticationCodeMutation, 'userId'>
  )> }
);

export type ISetUserPasswordMutationVariables = Exact<{
  uid: Scalars['String'];
  token: Scalars['String'];
  isInitialSignup?: Maybe<Scalars['Boolean']>;
  userData: IUserSignupArgsType;
}>;


export type ISetUserPasswordMutation = (
  { __typename?: 'Mutation' }
  & { setPassword?: Maybe<(
    { __typename?: 'SetPasswordMutation' }
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & Pick<IUserType, 'id'>
    )> }
  )> }
);

export type IFetchUserAndCompanyQueryVariables = Exact<{
  uid: Scalars['String'];
  token: Scalars['String'];
}>;


export type IFetchUserAndCompanyQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'UserType' }
    & Pick<IUserType, 'id' | 'firstName' | 'lastNamePrefix' | 'lastName' | 'email' | 'jobTitle' | 'phone' | 'isMainUser' | 'locale'>
    & { company: (
      { __typename?: 'CompanyType' }
      & Pick<ICompanyType, 'name' | 'street' | 'houseNumber' | 'houseNumberAdditional' | 'zipCode' | 'city' | 'btwId'>
    ) }
  )> }
);

export type IVerifyPasswordResetTokenQueryVariables = Exact<{
  uid: Scalars['String'];
  token: Scalars['String'];
}>;


export type IVerifyPasswordResetTokenQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'UserType' }
    & Pick<IUserType, 'id'>
  )> }
);

export type ICompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type ICompanyQuery = (
  { __typename?: 'Query' }
  & { company: (
    { __typename?: 'CompanyType' }
    & Pick<ICompanyType, 'id' | 'name' | 'street' | 'houseNumber' | 'houseNumberAdditional' | 'zipCode' | 'city' | 'btwId' | 'fallbackEmail' | 'invoiceCompanyName' | 'invoiceName' | 'invoiceEmail'>
    & { budgets: Array<(
      { __typename?: 'BudgetType' }
      & Pick<IBudgetType, 'id' | 'name' | 'description' | 'infoUrl'>
    )>, users: Array<(
      { __typename?: 'UserType' }
      & Pick<IUserType, 'id' | 'firstName' | 'lastNamePrefix' | 'lastName' | 'email' | 'jobTitle' | 'phone' | 'isMainUser' | 'locale'>
    )> }
  ) }
);

export type ICompanyBudgetsQueryVariables = Exact<{ [key: string]: never; }>;


export type ICompanyBudgetsQuery = (
  { __typename?: 'Query' }
  & { company: (
    { __typename?: 'CompanyType' }
    & { budgets: Array<(
      { __typename?: 'BudgetType' }
      & Pick<IBudgetType, 'id' | 'name'>
    )> }
  ) }
);

export type IInvitationsCancelMutationVariables = Exact<{
  ids: Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>;
}>;


export type IInvitationsCancelMutation = (
  { __typename?: 'Mutation' }
  & { cancelInvitations?: Maybe<(
    { __typename?: 'CancelInvitationsMutation' }
    & Pick<ICancelInvitationsMutation, 'success'>
  )> }
);

export type IEmployeeCreateAndInviteMutationVariables = Exact<{
  employeeData: ICreateEmployeeArgumentsType;
}>;


export type IEmployeeCreateAndInviteMutation = (
  { __typename?: 'Mutation' }
  & { createAndInviteEmployee?: Maybe<(
    { __typename?: 'CreateEmployeeMutation' }
    & Pick<ICreateEmployeeMutation, 'success'>
    & { employee: (
      { __typename?: 'EmployeeType' }
      & Pick<IEmployeeType, 'id' | 'firstName' | 'lastNamePrefix' | 'lastName'>
    ) }
  )> }
);

export type IInvitationsCreateMutationVariables = Exact<{
  employeeId: Scalars['ID'];
  budgetIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type IInvitationsCreateMutation = (
  { __typename?: 'Mutation' }
  & { createInvitations?: Maybe<(
    { __typename?: 'CreateInvitationsMutation' }
    & { invitations?: Maybe<Array<(
      { __typename?: 'InvitationType' }
      & Pick<IInvitationType, 'id'>
    )>> }
  )> }
);

export type IRemoveEmployeesMutationVariables = Exact<{
  idList: Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>;
}>;


export type IRemoveEmployeesMutation = (
  { __typename?: 'Mutation' }
  & { deleteEmployees?: Maybe<(
    { __typename?: 'DeleteEmployeesMutation' }
    & Pick<IDeleteEmployeesMutation, 'success'>
  )> }
);

export type IOptOutMutationVariables = Exact<{
  token: Scalars['UUID'];
  mailingIds: Array<IMailingId> | IMailingId;
}>;


export type IOptOutMutation = (
  { __typename?: 'Mutation' }
  & { optOutEmployee?: Maybe<(
    { __typename?: 'EmployeeMailOptOutMutation' }
    & Pick<IEmployeeMailOptOutMutation, 'success'>
  )> }
);

export type IResendEmployeeInvitationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IResendEmployeeInvitationMutation = (
  { __typename?: 'Mutation' }
  & { resendInvitation?: Maybe<(
    { __typename?: 'ResendInvitationMutation' }
    & Pick<IResendInvitationMutation, 'success'>
  )> }
);

export type IEmployeeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IEmployeeQuery = (
  { __typename?: 'Query' }
  & { employee?: Maybe<(
    { __typename?: 'EmployeeType' }
    & Pick<IEmployeeType, 'id' | 'firstName' | 'lastNamePrefix' | 'lastName' | 'email' | 'personnelNumber'>
    & { invitations: Array<(
      { __typename?: 'InvitationType' }
      & Pick<IInvitationType, 'id' | 'externalId' | 'createdAt' | 'statusDisplay' | 'lastSent' | 'canSend'>
      & { budget: (
        { __typename?: 'BudgetType' }
        & Pick<IBudgetType, 'name'>
      ) }
    )>, company: (
      { __typename?: 'CompanyType' }
      & { budgets: Array<(
        { __typename?: 'BudgetType' }
        & Pick<IBudgetType, 'id' | 'name'>
      )> }
    ) }
  )> }
);

export type IInvitationsQueryVariables = Exact<{
  orderBy?: Maybe<IEmployeeOrder>;
  ascending?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  budgetId?: Maybe<Scalars['ID']>;
  status?: Maybe<IInvitationStatus>;
}>;


export type IInvitationsQuery = (
  { __typename?: 'Query' }
  & { invitations: (
    { __typename?: 'PaginatedInvitationsType' }
    & Pick<IPaginatedInvitationsType, 'count'>
    & { objects: Array<(
      { __typename?: 'InvitationType' }
      & Pick<IInvitationType, 'id' | 'statusDisplay' | 'updatedAt'>
      & { budget: (
        { __typename?: 'BudgetType' }
        & Pick<IBudgetType, 'name'>
      ), employee: (
        { __typename?: 'EmployeeType' }
        & Pick<IEmployeeType, 'id' | 'firstName' | 'lastNamePrefix' | 'lastName'>
      ) }
    )> }
  ) }
);

export type IEmployeesAndBudgetsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
}>;


export type IEmployeesAndBudgetsQuery = (
  { __typename?: 'Query' }
  & { employees: (
    { __typename?: 'PaginatedEmployeesType' }
    & { objects: Array<(
      { __typename?: 'EmployeeType' }
      & Pick<IEmployeeType, 'id' | 'firstName' | 'lastNamePrefix' | 'lastName' | 'email' | 'personnelNumber'>
    )> }
  ), company: (
    { __typename?: 'CompanyType' }
    & { budgets: Array<(
      { __typename?: 'BudgetType' }
      & Pick<IBudgetType, 'id' | 'name'>
    )> }
  ) }
);

export type IEmployeeFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type IEmployeeFiltersQuery = (
  { __typename?: 'Query' }
  & Pick<IQuery, 'invitationStatusses'>
  & { company: (
    { __typename?: 'CompanyType' }
    & { budgets: Array<(
      { __typename?: 'BudgetType' }
      & Pick<IBudgetType, 'id' | 'name'>
    )> }
  ) }
);

export type IInvitationsExportQueryVariables = Exact<{ [key: string]: never; }>;


export type IInvitationsExportQuery = (
  { __typename?: 'Query' }
  & { invitations: (
    { __typename?: 'PaginatedInvitationsType' }
    & { objects: Array<(
      { __typename?: 'InvitationType' }
      & Pick<IInvitationType, 'externalId' | 'lastSent' | 'statusDisplay'>
      & { employee: (
        { __typename?: 'EmployeeType' }
        & Pick<IEmployeeType, 'firstName' | 'lastNamePrefix' | 'lastName' | 'email' | 'personnelNumber'>
      ), budget: (
        { __typename?: 'BudgetType' }
        & Pick<IBudgetType, 'name'>
      ) }
    )> }
  ) }
);

export type IUserCreateMutationVariables = Exact<{
  userData: ICreateUserArgumentsType;
}>;


export type IUserCreateMutation = (
  { __typename?: 'Mutation' }
  & { createUser?: Maybe<(
    { __typename?: 'CreateUserMutation' }
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & Pick<IUserType, 'id' | 'firstName' | 'lastNamePrefix' | 'lastName' | 'email' | 'jobTitle' | 'phone'>
    )> }
  )> }
);

export type IUserDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IUserDeleteMutation = (
  { __typename?: 'Mutation' }
  & { deleteUser?: Maybe<(
    { __typename?: 'DeleteUserMutation' }
    & Pick<IDeleteUserMutation, 'success'>
  )> }
);

export type IUserUpdateMutationVariables = Exact<{
  userData: IUpdateUserArgumentsType;
}>;


export type IUserUpdateMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'UpdateUserMutation' }
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & Pick<IUserType, 'id' | 'firstName' | 'lastNamePrefix' | 'lastName' | 'jobTitle' | 'phone'>
    )> }
  )> }
);

export type IUserQueryVariables = Exact<{
  uid?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
}>;


export type IUserQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'UserType' }
    & Pick<IUserType, 'id' | 'firstName' | 'lastNamePrefix' | 'lastName' | 'email' | 'jobTitle' | 'phone' | 'isMainUser' | 'locale'>
    & { company: (
      { __typename?: 'CompanyType' }
      & Pick<ICompanyType, 'id' | 'name'>
    ) }
  )> }
);


export const InvitationValidDocument = gql`
    query InvitationValid($invitationId: String!) {
  invitationValid(invitationId: $invitationId)
}
    `;

/**
 * __useInvitationValidQuery__
 *
 * To run a query within a React component, call `useInvitationValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationValidQuery({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useInvitationValidQuery(baseOptions: Apollo.QueryHookOptions<IInvitationValidQuery, IInvitationValidQueryVariables>) {
        return Apollo.useQuery<IInvitationValidQuery, IInvitationValidQueryVariables>(InvitationValidDocument, baseOptions);
      }
export function useInvitationValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IInvitationValidQuery, IInvitationValidQueryVariables>) {
          return Apollo.useLazyQuery<IInvitationValidQuery, IInvitationValidQueryVariables>(InvitationValidDocument, baseOptions);
        }
export type InvitationValidQueryHookResult = ReturnType<typeof useInvitationValidQuery>;
export type InvitationValidLazyQueryHookResult = ReturnType<typeof useInvitationValidLazyQuery>;
export type InvitationValidQueryResult = Apollo.QueryResult<IInvitationValidQuery, IInvitationValidQueryVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!) {
  resetPassword(email: $email) {
    received
  }
}
    `;
export type IForgotPasswordMutationFn = Apollo.MutationFunction<IForgotPasswordMutation, IForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<IForgotPasswordMutation, IForgotPasswordMutationVariables>) {
        return Apollo.useMutation<IForgotPasswordMutation, IForgotPasswordMutationVariables>(ForgotPasswordDocument, baseOptions);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<IForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<IForgotPasswordMutation, IForgotPasswordMutationVariables>;
export const ObtainAuthTokenDocument = gql`
    mutation ObtainAuthToken($code: String!, $userId: ID!) {
  obtainToken(code: $code, userId: $userId) {
    token
    refreshExpiresIn
  }
}
    `;
export type IObtainAuthTokenMutationFn = Apollo.MutationFunction<IObtainAuthTokenMutation, IObtainAuthTokenMutationVariables>;

/**
 * __useObtainAuthTokenMutation__
 *
 * To run a mutation, you first call `useObtainAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObtainAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [obtainAuthTokenMutation, { data, loading, error }] = useObtainAuthTokenMutation({
 *   variables: {
 *      code: // value for 'code'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useObtainAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<IObtainAuthTokenMutation, IObtainAuthTokenMutationVariables>) {
        return Apollo.useMutation<IObtainAuthTokenMutation, IObtainAuthTokenMutationVariables>(ObtainAuthTokenDocument, baseOptions);
      }
export type ObtainAuthTokenMutationHookResult = ReturnType<typeof useObtainAuthTokenMutation>;
export type ObtainAuthTokenMutationResult = Apollo.MutationResult<IObtainAuthTokenMutation>;
export type ObtainAuthTokenMutationOptions = Apollo.BaseMutationOptions<IObtainAuthTokenMutation, IObtainAuthTokenMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken {
  refreshToken {
    token
    refreshExpiresIn
  }
}
    `;
export type IRefreshTokenMutationFn = Apollo.MutationFunction<IRefreshTokenMutation, IRefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<IRefreshTokenMutation, IRefreshTokenMutationVariables>) {
        return Apollo.useMutation<IRefreshTokenMutation, IRefreshTokenMutationVariables>(RefreshTokenDocument, baseOptions);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<IRefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<IRefreshTokenMutation, IRefreshTokenMutationVariables>;
export const RequestAuthCodeDocument = gql`
    mutation RequestAuthCode($email: String!, $password: String!) {
  requestAuthenticationCode(email: $email, password: $password) {
    userId
  }
}
    `;
export type IRequestAuthCodeMutationFn = Apollo.MutationFunction<IRequestAuthCodeMutation, IRequestAuthCodeMutationVariables>;

/**
 * __useRequestAuthCodeMutation__
 *
 * To run a mutation, you first call `useRequestAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAuthCodeMutation, { data, loading, error }] = useRequestAuthCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useRequestAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<IRequestAuthCodeMutation, IRequestAuthCodeMutationVariables>) {
        return Apollo.useMutation<IRequestAuthCodeMutation, IRequestAuthCodeMutationVariables>(RequestAuthCodeDocument, baseOptions);
      }
export type RequestAuthCodeMutationHookResult = ReturnType<typeof useRequestAuthCodeMutation>;
export type RequestAuthCodeMutationResult = Apollo.MutationResult<IRequestAuthCodeMutation>;
export type RequestAuthCodeMutationOptions = Apollo.BaseMutationOptions<IRequestAuthCodeMutation, IRequestAuthCodeMutationVariables>;
export const SetUserPasswordDocument = gql`
    mutation SetUserPassword($uid: String!, $token: String!, $isInitialSignup: Boolean, $userData: UserSignupArgsType!) {
  setPassword(
    uid: $uid
    token: $token
    isInitialSignup: $isInitialSignup
    userData: $userData
  ) {
    user {
      id
    }
  }
}
    `;
export type ISetUserPasswordMutationFn = Apollo.MutationFunction<ISetUserPasswordMutation, ISetUserPasswordMutationVariables>;

/**
 * __useSetUserPasswordMutation__
 *
 * To run a mutation, you first call `useSetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPasswordMutation, { data, loading, error }] = useSetUserPasswordMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      token: // value for 'token'
 *      isInitialSignup: // value for 'isInitialSignup'
 *      userData: // value for 'userData'
 *   },
 * });
 */
export function useSetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ISetUserPasswordMutation, ISetUserPasswordMutationVariables>) {
        return Apollo.useMutation<ISetUserPasswordMutation, ISetUserPasswordMutationVariables>(SetUserPasswordDocument, baseOptions);
      }
export type SetUserPasswordMutationHookResult = ReturnType<typeof useSetUserPasswordMutation>;
export type SetUserPasswordMutationResult = Apollo.MutationResult<ISetUserPasswordMutation>;
export type SetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ISetUserPasswordMutation, ISetUserPasswordMutationVariables>;
export const FetchUserAndCompanyDocument = gql`
    query FetchUserAndCompany($uid: String!, $token: String!) {
  user(uid: $uid, token: $token) {
    id
    firstName
    lastNamePrefix
    lastName
    email
    company {
      name
      street
      houseNumber
      houseNumberAdditional
      zipCode
      city
      btwId
    }
    jobTitle
    phone
    isMainUser
    locale
  }
}
    `;

/**
 * __useFetchUserAndCompanyQuery__
 *
 * To run a query within a React component, call `useFetchUserAndCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserAndCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserAndCompanyQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useFetchUserAndCompanyQuery(baseOptions: Apollo.QueryHookOptions<IFetchUserAndCompanyQuery, IFetchUserAndCompanyQueryVariables>) {
        return Apollo.useQuery<IFetchUserAndCompanyQuery, IFetchUserAndCompanyQueryVariables>(FetchUserAndCompanyDocument, baseOptions);
      }
export function useFetchUserAndCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchUserAndCompanyQuery, IFetchUserAndCompanyQueryVariables>) {
          return Apollo.useLazyQuery<IFetchUserAndCompanyQuery, IFetchUserAndCompanyQueryVariables>(FetchUserAndCompanyDocument, baseOptions);
        }
export type FetchUserAndCompanyQueryHookResult = ReturnType<typeof useFetchUserAndCompanyQuery>;
export type FetchUserAndCompanyLazyQueryHookResult = ReturnType<typeof useFetchUserAndCompanyLazyQuery>;
export type FetchUserAndCompanyQueryResult = Apollo.QueryResult<IFetchUserAndCompanyQuery, IFetchUserAndCompanyQueryVariables>;
export const VerifyPasswordResetTokenDocument = gql`
    query VerifyPasswordResetToken($uid: String!, $token: String!) {
  user(uid: $uid, token: $token) {
    id
  }
}
    `;

/**
 * __useVerifyPasswordResetTokenQuery__
 *
 * To run a query within a React component, call `useVerifyPasswordResetTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyPasswordResetTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyPasswordResetTokenQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyPasswordResetTokenQuery(baseOptions: Apollo.QueryHookOptions<IVerifyPasswordResetTokenQuery, IVerifyPasswordResetTokenQueryVariables>) {
        return Apollo.useQuery<IVerifyPasswordResetTokenQuery, IVerifyPasswordResetTokenQueryVariables>(VerifyPasswordResetTokenDocument, baseOptions);
      }
export function useVerifyPasswordResetTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IVerifyPasswordResetTokenQuery, IVerifyPasswordResetTokenQueryVariables>) {
          return Apollo.useLazyQuery<IVerifyPasswordResetTokenQuery, IVerifyPasswordResetTokenQueryVariables>(VerifyPasswordResetTokenDocument, baseOptions);
        }
export type VerifyPasswordResetTokenQueryHookResult = ReturnType<typeof useVerifyPasswordResetTokenQuery>;
export type VerifyPasswordResetTokenLazyQueryHookResult = ReturnType<typeof useVerifyPasswordResetTokenLazyQuery>;
export type VerifyPasswordResetTokenQueryResult = Apollo.QueryResult<IVerifyPasswordResetTokenQuery, IVerifyPasswordResetTokenQueryVariables>;
export const CompanyDocument = gql`
    query Company {
  company {
    id
    name
    street
    houseNumber
    houseNumberAdditional
    zipCode
    city
    btwId
    fallbackEmail
    invoiceCompanyName
    invoiceName
    invoiceEmail
    budgets {
      id
      name
      description
      infoUrl
    }
    users {
      id
      firstName
      lastNamePrefix
      lastName
      email
      jobTitle
      phone
      isMainUser
      locale
    }
  }
}
    `;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyQuery(baseOptions?: Apollo.QueryHookOptions<ICompanyQuery, ICompanyQueryVariables>) {
        return Apollo.useQuery<ICompanyQuery, ICompanyQueryVariables>(CompanyDocument, baseOptions);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICompanyQuery, ICompanyQueryVariables>) {
          return Apollo.useLazyQuery<ICompanyQuery, ICompanyQueryVariables>(CompanyDocument, baseOptions);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = Apollo.QueryResult<ICompanyQuery, ICompanyQueryVariables>;
export const CompanyBudgetsDocument = gql`
    query CompanyBudgets {
  company {
    budgets {
      id
      name
    }
  }
}
    `;

/**
 * __useCompanyBudgetsQuery__
 *
 * To run a query within a React component, call `useCompanyBudgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyBudgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyBudgetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyBudgetsQuery(baseOptions?: Apollo.QueryHookOptions<ICompanyBudgetsQuery, ICompanyBudgetsQueryVariables>) {
        return Apollo.useQuery<ICompanyBudgetsQuery, ICompanyBudgetsQueryVariables>(CompanyBudgetsDocument, baseOptions);
      }
export function useCompanyBudgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICompanyBudgetsQuery, ICompanyBudgetsQueryVariables>) {
          return Apollo.useLazyQuery<ICompanyBudgetsQuery, ICompanyBudgetsQueryVariables>(CompanyBudgetsDocument, baseOptions);
        }
export type CompanyBudgetsQueryHookResult = ReturnType<typeof useCompanyBudgetsQuery>;
export type CompanyBudgetsLazyQueryHookResult = ReturnType<typeof useCompanyBudgetsLazyQuery>;
export type CompanyBudgetsQueryResult = Apollo.QueryResult<ICompanyBudgetsQuery, ICompanyBudgetsQueryVariables>;
export const InvitationsCancelDocument = gql`
    mutation InvitationsCancel($ids: [ID]!) {
  cancelInvitations(ids: $ids) {
    success
  }
}
    `;
export type IInvitationsCancelMutationFn = Apollo.MutationFunction<IInvitationsCancelMutation, IInvitationsCancelMutationVariables>;

/**
 * __useInvitationsCancelMutation__
 *
 * To run a mutation, you first call `useInvitationsCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationsCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationsCancelMutation, { data, loading, error }] = useInvitationsCancelMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useInvitationsCancelMutation(baseOptions?: Apollo.MutationHookOptions<IInvitationsCancelMutation, IInvitationsCancelMutationVariables>) {
        return Apollo.useMutation<IInvitationsCancelMutation, IInvitationsCancelMutationVariables>(InvitationsCancelDocument, baseOptions);
      }
export type InvitationsCancelMutationHookResult = ReturnType<typeof useInvitationsCancelMutation>;
export type InvitationsCancelMutationResult = Apollo.MutationResult<IInvitationsCancelMutation>;
export type InvitationsCancelMutationOptions = Apollo.BaseMutationOptions<IInvitationsCancelMutation, IInvitationsCancelMutationVariables>;
export const EmployeeCreateAndInviteDocument = gql`
    mutation employeeCreateAndInvite($employeeData: CreateEmployeeArgumentsType!) {
  createAndInviteEmployee(employeeData: $employeeData, skipDuplicateError: true) {
    employee {
      id
      firstName
      lastNamePrefix
      lastName
    }
    success
  }
}
    `;
export type IEmployeeCreateAndInviteMutationFn = Apollo.MutationFunction<IEmployeeCreateAndInviteMutation, IEmployeeCreateAndInviteMutationVariables>;

/**
 * __useEmployeeCreateAndInviteMutation__
 *
 * To run a mutation, you first call `useEmployeeCreateAndInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeCreateAndInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeCreateAndInviteMutation, { data, loading, error }] = useEmployeeCreateAndInviteMutation({
 *   variables: {
 *      employeeData: // value for 'employeeData'
 *   },
 * });
 */
export function useEmployeeCreateAndInviteMutation(baseOptions?: Apollo.MutationHookOptions<IEmployeeCreateAndInviteMutation, IEmployeeCreateAndInviteMutationVariables>) {
        return Apollo.useMutation<IEmployeeCreateAndInviteMutation, IEmployeeCreateAndInviteMutationVariables>(EmployeeCreateAndInviteDocument, baseOptions);
      }
export type EmployeeCreateAndInviteMutationHookResult = ReturnType<typeof useEmployeeCreateAndInviteMutation>;
export type EmployeeCreateAndInviteMutationResult = Apollo.MutationResult<IEmployeeCreateAndInviteMutation>;
export type EmployeeCreateAndInviteMutationOptions = Apollo.BaseMutationOptions<IEmployeeCreateAndInviteMutation, IEmployeeCreateAndInviteMutationVariables>;
export const InvitationsCreateDocument = gql`
    mutation invitationsCreate($employeeId: ID!, $budgetIds: [ID!]!) {
  createInvitations(employeeId: $employeeId, budgetIds: $budgetIds) {
    invitations {
      id
    }
  }
}
    `;
export type IInvitationsCreateMutationFn = Apollo.MutationFunction<IInvitationsCreateMutation, IInvitationsCreateMutationVariables>;

/**
 * __useInvitationsCreateMutation__
 *
 * To run a mutation, you first call `useInvitationsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationsCreateMutation, { data, loading, error }] = useInvitationsCreateMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      budgetIds: // value for 'budgetIds'
 *   },
 * });
 */
export function useInvitationsCreateMutation(baseOptions?: Apollo.MutationHookOptions<IInvitationsCreateMutation, IInvitationsCreateMutationVariables>) {
        return Apollo.useMutation<IInvitationsCreateMutation, IInvitationsCreateMutationVariables>(InvitationsCreateDocument, baseOptions);
      }
export type InvitationsCreateMutationHookResult = ReturnType<typeof useInvitationsCreateMutation>;
export type InvitationsCreateMutationResult = Apollo.MutationResult<IInvitationsCreateMutation>;
export type InvitationsCreateMutationOptions = Apollo.BaseMutationOptions<IInvitationsCreateMutation, IInvitationsCreateMutationVariables>;
export const RemoveEmployeesDocument = gql`
    mutation RemoveEmployees($idList: [ID]!) {
  deleteEmployees(idList: $idList) {
    success
  }
}
    `;
export type IRemoveEmployeesMutationFn = Apollo.MutationFunction<IRemoveEmployeesMutation, IRemoveEmployeesMutationVariables>;

/**
 * __useRemoveEmployeesMutation__
 *
 * To run a mutation, you first call `useRemoveEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmployeesMutation, { data, loading, error }] = useRemoveEmployeesMutation({
 *   variables: {
 *      idList: // value for 'idList'
 *   },
 * });
 */
export function useRemoveEmployeesMutation(baseOptions?: Apollo.MutationHookOptions<IRemoveEmployeesMutation, IRemoveEmployeesMutationVariables>) {
        return Apollo.useMutation<IRemoveEmployeesMutation, IRemoveEmployeesMutationVariables>(RemoveEmployeesDocument, baseOptions);
      }
export type RemoveEmployeesMutationHookResult = ReturnType<typeof useRemoveEmployeesMutation>;
export type RemoveEmployeesMutationResult = Apollo.MutationResult<IRemoveEmployeesMutation>;
export type RemoveEmployeesMutationOptions = Apollo.BaseMutationOptions<IRemoveEmployeesMutation, IRemoveEmployeesMutationVariables>;
export const OptOutDocument = gql`
    mutation optOut($token: UUID!, $mailingIds: [MailingId!]!) {
  optOutEmployee(token: $token, mailingIds: $mailingIds) {
    success
  }
}
    `;
export type IOptOutMutationFn = Apollo.MutationFunction<IOptOutMutation, IOptOutMutationVariables>;

/**
 * __useOptOutMutation__
 *
 * To run a mutation, you first call `useOptOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optOutMutation, { data, loading, error }] = useOptOutMutation({
 *   variables: {
 *      token: // value for 'token'
 *      mailingIds: // value for 'mailingIds'
 *   },
 * });
 */
export function useOptOutMutation(baseOptions?: Apollo.MutationHookOptions<IOptOutMutation, IOptOutMutationVariables>) {
        return Apollo.useMutation<IOptOutMutation, IOptOutMutationVariables>(OptOutDocument, baseOptions);
      }
export type OptOutMutationHookResult = ReturnType<typeof useOptOutMutation>;
export type OptOutMutationResult = Apollo.MutationResult<IOptOutMutation>;
export type OptOutMutationOptions = Apollo.BaseMutationOptions<IOptOutMutation, IOptOutMutationVariables>;
export const ResendEmployeeInvitationDocument = gql`
    mutation resendEmployeeInvitation($id: ID!) {
  resendInvitation(invitationId: $id) {
    success
  }
}
    `;
export type IResendEmployeeInvitationMutationFn = Apollo.MutationFunction<IResendEmployeeInvitationMutation, IResendEmployeeInvitationMutationVariables>;

/**
 * __useResendEmployeeInvitationMutation__
 *
 * To run a mutation, you first call `useResendEmployeeInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmployeeInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmployeeInvitationMutation, { data, loading, error }] = useResendEmployeeInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendEmployeeInvitationMutation(baseOptions?: Apollo.MutationHookOptions<IResendEmployeeInvitationMutation, IResendEmployeeInvitationMutationVariables>) {
        return Apollo.useMutation<IResendEmployeeInvitationMutation, IResendEmployeeInvitationMutationVariables>(ResendEmployeeInvitationDocument, baseOptions);
      }
export type ResendEmployeeInvitationMutationHookResult = ReturnType<typeof useResendEmployeeInvitationMutation>;
export type ResendEmployeeInvitationMutationResult = Apollo.MutationResult<IResendEmployeeInvitationMutation>;
export type ResendEmployeeInvitationMutationOptions = Apollo.BaseMutationOptions<IResendEmployeeInvitationMutation, IResendEmployeeInvitationMutationVariables>;
export const EmployeeDocument = gql`
    query Employee($id: ID!) {
  employee(id: $id) {
    id
    firstName
    lastNamePrefix
    lastName
    email
    personnelNumber
    invitations {
      id
      budget {
        name
      }
      externalId
      createdAt
      statusDisplay
      lastSent
      canSend
    }
    company {
      budgets {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useEmployeeQuery__
 *
 * To run a query within a React component, call `useEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeQuery(baseOptions: Apollo.QueryHookOptions<IEmployeeQuery, IEmployeeQueryVariables>) {
        return Apollo.useQuery<IEmployeeQuery, IEmployeeQueryVariables>(EmployeeDocument, baseOptions);
      }
export function useEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IEmployeeQuery, IEmployeeQueryVariables>) {
          return Apollo.useLazyQuery<IEmployeeQuery, IEmployeeQueryVariables>(EmployeeDocument, baseOptions);
        }
export type EmployeeQueryHookResult = ReturnType<typeof useEmployeeQuery>;
export type EmployeeLazyQueryHookResult = ReturnType<typeof useEmployeeLazyQuery>;
export type EmployeeQueryResult = Apollo.QueryResult<IEmployeeQuery, IEmployeeQueryVariables>;
export const InvitationsDocument = gql`
    query Invitations($orderBy: EmployeeOrder, $ascending: Boolean, $offset: Int, $limit: Int, $search: String, $budgetId: ID, $status: InvitationStatus) {
  invitations(
    orderBy: $orderBy
    ascending: $ascending
    offset: $offset
    limit: $limit
    search: $search
    budgetId: $budgetId
    status: $status
  ) {
    count
    objects {
      id
      statusDisplay
      updatedAt
      budget {
        name
      }
      employee {
        id
        firstName
        lastNamePrefix
        lastName
      }
    }
  }
}
    `;

/**
 * __useInvitationsQuery__
 *
 * To run a query within a React component, call `useInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      ascending: // value for 'ascending'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      budgetId: // value for 'budgetId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<IInvitationsQuery, IInvitationsQueryVariables>) {
        return Apollo.useQuery<IInvitationsQuery, IInvitationsQueryVariables>(InvitationsDocument, baseOptions);
      }
export function useInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IInvitationsQuery, IInvitationsQueryVariables>) {
          return Apollo.useLazyQuery<IInvitationsQuery, IInvitationsQueryVariables>(InvitationsDocument, baseOptions);
        }
export type InvitationsQueryHookResult = ReturnType<typeof useInvitationsQuery>;
export type InvitationsLazyQueryHookResult = ReturnType<typeof useInvitationsLazyQuery>;
export type InvitationsQueryResult = Apollo.QueryResult<IInvitationsQuery, IInvitationsQueryVariables>;
export const EmployeesAndBudgetsDocument = gql`
    query EmployeesAndBudgets($search: String) {
  employees(limit: 50, search: $search) {
    objects {
      id
      firstName
      lastNamePrefix
      lastName
      email
      personnelNumber
    }
  }
  company {
    budgets {
      id
      name
    }
  }
}
    `;

/**
 * __useEmployeesAndBudgetsQuery__
 *
 * To run a query within a React component, call `useEmployeesAndBudgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesAndBudgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesAndBudgetsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useEmployeesAndBudgetsQuery(baseOptions?: Apollo.QueryHookOptions<IEmployeesAndBudgetsQuery, IEmployeesAndBudgetsQueryVariables>) {
        return Apollo.useQuery<IEmployeesAndBudgetsQuery, IEmployeesAndBudgetsQueryVariables>(EmployeesAndBudgetsDocument, baseOptions);
      }
export function useEmployeesAndBudgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IEmployeesAndBudgetsQuery, IEmployeesAndBudgetsQueryVariables>) {
          return Apollo.useLazyQuery<IEmployeesAndBudgetsQuery, IEmployeesAndBudgetsQueryVariables>(EmployeesAndBudgetsDocument, baseOptions);
        }
export type EmployeesAndBudgetsQueryHookResult = ReturnType<typeof useEmployeesAndBudgetsQuery>;
export type EmployeesAndBudgetsLazyQueryHookResult = ReturnType<typeof useEmployeesAndBudgetsLazyQuery>;
export type EmployeesAndBudgetsQueryResult = Apollo.QueryResult<IEmployeesAndBudgetsQuery, IEmployeesAndBudgetsQueryVariables>;
export const EmployeeFiltersDocument = gql`
    query EmployeeFilters {
  company {
    budgets {
      id
      name
    }
  }
  invitationStatusses
}
    `;

/**
 * __useEmployeeFiltersQuery__
 *
 * To run a query within a React component, call `useEmployeeFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeFiltersQuery(baseOptions?: Apollo.QueryHookOptions<IEmployeeFiltersQuery, IEmployeeFiltersQueryVariables>) {
        return Apollo.useQuery<IEmployeeFiltersQuery, IEmployeeFiltersQueryVariables>(EmployeeFiltersDocument, baseOptions);
      }
export function useEmployeeFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IEmployeeFiltersQuery, IEmployeeFiltersQueryVariables>) {
          return Apollo.useLazyQuery<IEmployeeFiltersQuery, IEmployeeFiltersQueryVariables>(EmployeeFiltersDocument, baseOptions);
        }
export type EmployeeFiltersQueryHookResult = ReturnType<typeof useEmployeeFiltersQuery>;
export type EmployeeFiltersLazyQueryHookResult = ReturnType<typeof useEmployeeFiltersLazyQuery>;
export type EmployeeFiltersQueryResult = Apollo.QueryResult<IEmployeeFiltersQuery, IEmployeeFiltersQueryVariables>;
export const InvitationsExportDocument = gql`
    query InvitationsExport {
  invitations {
    objects {
      externalId
      lastSent
      statusDisplay
      employee {
        firstName
        lastNamePrefix
        lastName
        email
        personnelNumber
      }
      budget {
        name
      }
    }
  }
}
    `;

/**
 * __useInvitationsExportQuery__
 *
 * To run a query within a React component, call `useInvitationsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsExportQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvitationsExportQuery(baseOptions?: Apollo.QueryHookOptions<IInvitationsExportQuery, IInvitationsExportQueryVariables>) {
        return Apollo.useQuery<IInvitationsExportQuery, IInvitationsExportQueryVariables>(InvitationsExportDocument, baseOptions);
      }
export function useInvitationsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IInvitationsExportQuery, IInvitationsExportQueryVariables>) {
          return Apollo.useLazyQuery<IInvitationsExportQuery, IInvitationsExportQueryVariables>(InvitationsExportDocument, baseOptions);
        }
export type InvitationsExportQueryHookResult = ReturnType<typeof useInvitationsExportQuery>;
export type InvitationsExportLazyQueryHookResult = ReturnType<typeof useInvitationsExportLazyQuery>;
export type InvitationsExportQueryResult = Apollo.QueryResult<IInvitationsExportQuery, IInvitationsExportQueryVariables>;
export const UserCreateDocument = gql`
    mutation UserCreate($userData: CreateUserArgumentsType!) {
  createUser(userData: $userData) {
    user {
      id
      firstName
      lastNamePrefix
      lastName
      email
      jobTitle
      phone
    }
  }
}
    `;
export type IUserCreateMutationFn = Apollo.MutationFunction<IUserCreateMutation, IUserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      userData: // value for 'userData'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<IUserCreateMutation, IUserCreateMutationVariables>) {
        return Apollo.useMutation<IUserCreateMutation, IUserCreateMutationVariables>(UserCreateDocument, baseOptions);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<IUserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<IUserCreateMutation, IUserCreateMutationVariables>;
export const UserDeleteDocument = gql`
    mutation UserDelete($id: ID!) {
  deleteUser(id: $id) {
    success
  }
}
    `;
export type IUserDeleteMutationFn = Apollo.MutationFunction<IUserDeleteMutation, IUserDeleteMutationVariables>;

/**
 * __useUserDeleteMutation__
 *
 * To run a mutation, you first call `useUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteMutation, { data, loading, error }] = useUserDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDeleteMutation(baseOptions?: Apollo.MutationHookOptions<IUserDeleteMutation, IUserDeleteMutationVariables>) {
        return Apollo.useMutation<IUserDeleteMutation, IUserDeleteMutationVariables>(UserDeleteDocument, baseOptions);
      }
export type UserDeleteMutationHookResult = ReturnType<typeof useUserDeleteMutation>;
export type UserDeleteMutationResult = Apollo.MutationResult<IUserDeleteMutation>;
export type UserDeleteMutationOptions = Apollo.BaseMutationOptions<IUserDeleteMutation, IUserDeleteMutationVariables>;
export const UserUpdateDocument = gql`
    mutation UserUpdate($userData: UpdateUserArgumentsType!) {
  updateUser(userData: $userData) {
    user {
      id
      firstName
      lastNamePrefix
      lastName
      jobTitle
      phone
    }
  }
}
    `;
export type IUserUpdateMutationFn = Apollo.MutationFunction<IUserUpdateMutation, IUserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      userData: // value for 'userData'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<IUserUpdateMutation, IUserUpdateMutationVariables>) {
        return Apollo.useMutation<IUserUpdateMutation, IUserUpdateMutationVariables>(UserUpdateDocument, baseOptions);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<IUserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<IUserUpdateMutation, IUserUpdateMutationVariables>;
export const UserDocument = gql`
    query User($uid: String, $token: String) {
  user(uid: $uid, token: $token) {
    id
    firstName
    lastNamePrefix
    lastName
    email
    company {
      id
      name
    }
    jobTitle
    phone
    isMainUser
    locale
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<IUserQuery, IUserQueryVariables>) {
        return Apollo.useQuery<IUserQuery, IUserQueryVariables>(UserDocument, baseOptions);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUserQuery, IUserQueryVariables>) {
          return Apollo.useLazyQuery<IUserQuery, IUserQueryVariables>(UserDocument, baseOptions);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<IUserQuery, IUserQueryVariables>;